import Pagination from "../../../../components/Pagination.vue";
import AIModelService from "../../../../services/AIModel.service";
import { alertResponseError, alertResponseSuccess } from "../../../../helpers/general";
import { ERRORS_CODE } from "../../../../const/error_code";
import { LAYER_TYPE } from "../../../../const/aimodel";
import * as Swal from "sweetalert2";
import draggable from 'vuedraggable'

export default {
    components: {
        appPagination: Pagination,
        draggable
    },
    data() {
        return {
            pagination : {
                currentPage: 1,
                pageCount: 1,
            },
            arrModelLayers: [],
            aiModelId: '',
            aiModelName: '',
            LAYER_TYPE: LAYER_TYPE
      }
    },
    methods:{
        checkMove(event) {
            // can move if the element is not hidden layer
            return (event.draggedContext.element.type === LAYER_TYPE.hidden && 
                    event.relatedContext.element.type !== LAYER_TYPE.input &&
                    event.relatedContext.element.type !== LAYER_TYPE.output);
        },
        onDragEnd(event) {
            if (event.oldIndex !== event.newIndex) {

                let dispOrder = {
                    dragged: {
                        layer_no: this.arrModelLayers[event.newIndex].layer_no,
                        disp_order: event.newIndex
                    },
                    target: {
                        layer_no: this.arrModelLayers[event.oldIndex].layer_no,
                        disp_order: event.oldIndex
                    }
                };

                AIModelService.updateAIModelLayerDispOrder(this.aiModelId, dispOrder)
                    .then(() => {
                        this.arrModelLayers[event.oldIndex].disp_order = event.oldIndex;
                        this.arrModelLayers[event.newIndex].disp_order = event.newIndex;
                    }).catch((error) => {
                        alertResponseError(error);
                    });
            }
        },
        deleteAIModelLayer(aiModelId, layerNo) {
            Swal.fire({
                text: this.$t("ai_model_layer.confirm_delete_layer"),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ef8157',
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    AIModelService.deleteAIModelLayer(aiModelId, layerNo).then((response) => {
                        if (response.data.success) {
                            alertResponseSuccess(this.$t("common_message.delete_success"));
                            this.getLayersWithAiModelId(aiModelId);
                        }
                    }).catch((error) => {
                        alertResponseError(error);
                    });
                }
            });
        },
        getLayersWithAiModelId(id) {
            AIModelService.getLayersWithAiModelId(id).then((response) => {
                this.arrModelLayers = response.data.data.results;
                this.pagination.pageCount = response.data.data.count;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    alertResponseError(error);
                }
            });
        },
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        let model = JSON.parse(localStorage.getItem('selected_ai_model'));
        if (!model) {
            this.$router.push({name: 'ai-model-list'});
        }
        this.aiModelId = model.id;
        this.aiModelName = model.name;
        this.getLayersWithAiModelId(this.aiModelId);
    }
}